<template>
  <div>
    <div>
      <RealtimeCameras />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RealtimeCameras from "../../components/Realtime/RealtimeCameras.vue";

export default defineComponent({
  name: "RealtimePage",
  components: {
    RealtimeCameras
  }
});
</script>